import { AppTypedFilters, FilterTypeValue } from "@/components/filter/filter.types.ts";
import { getApprovalStatusSelectItems } from "@/types/approvals/approval.types.ts";
import { FilterItem, Multiselect } from "@skailer-com/uikit";
import { Control, Controller, FieldErrors } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const useAppFilterApprovalRenders = ({
  control,
  errors,
}: {
  control: Control;
  typedFilters: AppTypedFilters;
  errors: FieldErrors;
}) => {
  const { t } = useTranslation();

  const renderFilterApprovalStatus = (item: FilterItem<FilterTypeValue>) => {
    return (
      <Controller
        key={item.name}
        render={({ field: { value, onChange } }) => (
          <Multiselect
            label={t("common:status")}
            emptyTitle={t("common:select")}
            options={getApprovalStatusSelectItems()}
            values={value}
            onChange={onChange}
            isClearable
            error={errors[item.name]?.message as string}
          />
        )}
        control={control}
        name={item.name}
      />
    );
  };

  return {
    renderFilterApprovalStatus,
  };
};
